export const about = async (args: string[]): Promise<string> => {
  return `
    <p> Hi there 👋 </p>
    <a href="https://github.com/andythsu">
      <img align="center" src="https://github-readme-stats.vercel.app/api/top-langs/?username=andythsu&layout=compact&theme=gruvbox" alt="foo"/>
    </a>
    `;
};
